<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">          
                        <div class="col-lg-6 col-xs-12 col-xl-6 col-md-12">
                            <p class="page-text margin-bottom-15">
                                Gerencie abaixo as configurações globais do aplicativo.
                            </p>
                        </div>                                 
                        <div class="col-xl-12 margin-bottom-20 menu">
                            
                            <a class="button block-mobile small" v-on:click="setTab('lembrete-agendamento')" v-bind:class="{'transparent': tab != 'lembrete-agendamento', 'color-primary': tab == 'lembrete-agendamento'}">
                                <i class="material-icons">event</i>
                                Lembrete de agendamento
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('confirmacao-agendamento')" v-bind:class="{'transparent': tab != 'confirmacao-agendamento', 'color-primary': tab == 'confirmacao-agendamento'}">
                                <i class="material-icons">check_circle</i>
                                Confirmação de agendamento
                            </a>

                            <!-- <a class="button block-mobile small" v-on:click="setTab('lembrete-retorno-agendamento')" v-bind:class="{'transparent': tab != 'lembrete-retorno-agendamento', 'color-primary': tab == 'lembrete-retorno-agendamento'}">
                                <i class="material-icons">redo</i>
                                Lembrete para agendar retorno
                            </a> -->

                            <a class="button block-mobile small" v-on:click="setTab('feedback')" v-bind:class="{'transparent': tab != 'feedback', 'color-primary': tab == 'feedback'}">
                                <i class="material-icons">thumb_up</i>
                                Avaliações / Recomendações
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('sintomas')" v-bind:class="{'transparent': tab != 'sintomas', 'color-primary': tab == 'sintomas'}">
                                <i class="material-icons">assignment_turned_in</i>
                                Editar Popup de sintomas
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('politicas-de-privacidade')" v-bind:class="{'transparent': tab != 'politicas-de-privacidade', 'color-primary': tab == 'politicas-de-privacidade'}">
                                <i class="material-icons">description</i>
                                Editar políticas de privacidade
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('termos-de-uso')" v-bind:class="{'transparent': tab != 'termos-de-uso', 'color-primary': tab == 'termos-de-uso'}">
                                <i class="material-icons">description</i>
                                Editar termos de uso
                            </a>

                        </div>  

                        <div class="col-xl-12 scroll-to"></div>

                        <div class="col-xl-12 margin-top-10" v-show="tab == 'lembrete-agendamento'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">event</i>
                                            Lembrete de agendamento
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Enviar quantas horas antes?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-sms" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.smsEnviar">
                                                        <label for="lembrete-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-email" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.emailEnviar">
                                                        <label for="lembrete-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-whatsapp" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.whatsappEnviar">
                                                        <label for="lembrete-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-push" true-value="1" false-value="0" v-model="form['lembrete-agendamento'].objeto.pushEnviar">
                                                        <label for="lembrete-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['lembrete-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['lembrete-agendamento'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="lembreteAgendamentoEmailTexto"></trumbowyg>
                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['lembrete-agendamento'].objeto.emailTexto"></textarea> -->
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 180px;" v-model="form['lembrete-agendamento'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-agendamento'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
<!--                                             <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-agendamento'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div> -->
                                            <div v-show="form['lembrete-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-agendamento'].objeto.pushTexto" style="min-height: 180px;"></textarea>
                                                </div>
                                            </div>        


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div> 

                        <div class="col-xl-12 margin-top-10" v-show="tab == 'confirmacao-agendamento'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">check_circle</i>                                    
                                            Confirmação de agendamento
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Enviar quantos dias antes?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-sms" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.smsEnviar">
                                                        <label for="confirmacao-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-email" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.emailEnviar">
                                                        <label for="confirmacao-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-whatsapp" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.whatsappEnviar">
                                                        <label for="confirmacao-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="confirmacao-agendamento-push" true-value="1" false-value="0" v-model="form['confirmacao-agendamento'].objeto.pushEnviar">
                                                        <label for="confirmacao-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['confirmacao-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['confirmacao-agendamento'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="confirmacaoAgendamentoEmailTexto"></trumbowyg>
                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['confirmacao-agendamento'].objeto.emailTexto"></textarea> -->
                                                </div>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['confirmacao-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 180px;" v-model="form['confirmacao-agendamento'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['confirmacao-agendamento'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
<!--                                             <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['confirmacao-agendamento'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div> -->
                                            <div v-show="form['confirmacao-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['confirmacao-agendamento'].objeto.pushTexto" style="min-height: 180px;"></textarea>
                                                </div>
                                            </div>    

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>                            
                        </div>  
<!-- 
                        <div class="col-xl-12 margin-top-10" v-show="tab == 'lembrete-retorno-agendamento'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">redo</i>                                    
                                            Lembrete para agendar retorno
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Enviar depois de quantos dias?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-sms" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.smsEnviar">
                                                        <label for="lembrete-retorno-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-email" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.emailEnviar">
                                                        <label for="lembrete-retorno-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-whatsapp" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.whatsappEnviar">
                                                        <label for="lembrete-retorno-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-retorno-agendamento-push" true-value="1" false-value="0" v-model="form['lembrete-retorno-agendamento'].objeto.pushEnviar">
                                                        <label for="lembrete-retorno-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['lembrete-retorno-agendamento'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="lembreteRetornoAgendamentoEmailTexto"></trumbowyg>
                                                   
                                                </div>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['lembrete-retorno-agendamento'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-retorno-agendamento'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form['lembrete-retorno-agendamento'].objeto.pushLink" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form['lembrete-retorno-agendamento'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['lembrete-retorno-agendamento'].objeto.pushTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>    

                                            
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>                              
                        </div>  -->

                        <div class="col-xl-12 margin-top-10" v-show="tab == 'feedback'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">thumb_up</i>                                        
                                            Avaliações / Recomendações
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-xl-8 col-xs-12 col-md-8 col-lg-8 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Link para avaliar no Google</h5>
                                                    <input type="text" placeholder="..." v-model="form['feedback'].objeto.link" class="with-border">
                                                </div>
                                            </div>         
                                            <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Enviar depois de quantos minutos?</h5>
                                                    <input style="width: 90px;" type="number" placeholder="..." class="with-border" v-model="form['feedback'].objeto.tempo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-sms" true-value="1" false-value="0" v-model="form['feedback'].objeto.smsEnviar">
                                                        <label for="feedback-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-email" true-value="1" false-value="0" v-model="form['feedback'].objeto.emailEnviar">
                                                        <label for="feedback-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-whatsapp" true-value="1" false-value="0" v-model="form['feedback'].objeto.whatsappEnviar">
                                                        <label for="feedback-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="feedback-push" true-value="1" false-value="0" v-model="form['feedback'].objeto.pushEnviar">
                                                        <label for="feedback-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['feedback'].objeto.smsEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    SMS
                                                </h3>
                                            </div>

                                            <div v-show="form['feedback'].objeto.smsEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['feedback'].objeto.smsTexto" style="min-height: 70px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>

                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    E-mail
                                                </h3>
                                            </div>
                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['feedback'].objeto.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form['feedback'].objeto.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form['feedback'].objeto.emailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form['feedback'].objeto.emailTexto" :config="config" style="height: 400px;" class="" name="feedbackEmailTexto"></trumbowyg>
                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['feedback'].objeto.emailTexto"></textarea> -->
                                                </div>
                                            </div>

                                            <div v-show="form['feedback'].objeto.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    WhatsApp
                                                </h3>
                                            </div>

                                            <div v-show="form['feedback'].objeto.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form['feedback'].objeto.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div class="col-xl-12"></div>
                                            <div v-show="form['feedback'].objeto.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    Notificação push
                                                </h3>
                                            </div>
                                            <div v-show="form['feedback'].objeto.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form['feedback'].objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form['feedback'].objeto.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form['feedback'].objeto.pushTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>    

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>  
                        </div> 


                        <div class="col-xl-12 margin-top-10" v-if="tab == 'sintomas'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">assignment_turned_in</i>
                                            Popup de sintomas

                                            <a class="float-right" style="font-size: 12px;" v-on:click="$root.openSintomas()">(Ver exemplo)</a>
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="sintomas-habilitado" v-model="form.sintomas.objeto.habilitado" true-value="1" false-value="0">
                                                        <label for="sintomas-habilitado"><span class="checkbox-icon"></span> Envio ativado</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="Como você está se sentindo hoje?" v-model="form.sintomas.objeto.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div class="col-xl-12 col-md-12 col-lg-12 margin-bottom-20">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="Toque aqui para nos contar como você está =)" v-model="form.sintomas.objeto.pushTexto" class="with-border" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>        

                                            <div class="col-xs-12 margin-bottom-0">
                                                <div class="row margin-bottom-10" v-for="(item, index) in form.sintomas.objeto.itens">
                                                    <div class="col-xl-12">
                                                        <hr class="margin-bottom-30">
                                                    </div>        

                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field">
                                                            <h5>Pergunta #{{index+1}}</h5>
                                                            <div class="row">
                                                                <div class="col-xs-11">
                                                                    <textarea placeholder="..." name="texto" v-model="item.texto" class="with-border margin-bottom-5" style="min-height: 50px;"></textarea>
                                                                </div>
                                                                <div class="col-xs-1">
                                                                    <a class="margin-top-9 margin-right-10 block close-red" v-on:click="del(form.sintomas.objeto.itens, item)">
                                                                        <i class="material-icons">close</i>
                                                                    </a>
                                                                </div>
                                                            </div>                                                    
                                                        </div>
                                                    </div>    
                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field padding-left-10">
                                                            <h5>Alternativas</h5>
                                                            <div class="row" v-for="(item2, index2) in item.itens">
                                                                <div class="col-xs-11">
                                                                    <input type="text" placeholder="..." v-model="item2.texto" class="with-border margin-bottom-2">
                                                                </div>
                                                                <div class="col-xs-1">
                                                                    <a class="margin-top-9 margin-right-10 block close-red" v-on:click="del(form.sintomas.objeto.itens[index].itens, item2)">
                                                                        <i class="material-icons">close</i>
                                                                    </a>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-xs-12">
                                                                    <a class="button-basic margin-top-8" v-on:click="add(form.sintomas.objeto.itens[index].itens, {'texto': ''})">
                                                                        <i class="material-icons">add</i>
                                                                        Adicionar nova <b>alternativa</b>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>                                                                                       
                                                </div>                                                                                       
                                            </div>                                                                                                                              

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                                <hr>
                                                <a class="button-basic margin-top-8" v-on:click="add(form.sintomas.objeto.itens, {'texto': '', 'itens': []})">
                                                    <i class="material-icons">add</i>
                                                    Adicionar nova <b>pergunta</b>
                                                </a>
                                                <hr>
                                            </div>
                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form> 
                        </div> 


                        <div class="col-xl-12 margin-top-10" v-if="tab == 'termos-de-uso'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">description</i>
                                            Termos de uso
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-12 margin-bottom-15">
                                                <div class="submit-field">
                                                    <h5>Conteúdo:</h5>
                                                    <trumbowyg v-model="form['termos-de-uso'].objeto.conteudo" :config="config" class="" name="termosUso"></trumbowyg>
                                                </div>
                                            </div>                                          

                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div> 


                        <div class="col-xl-12 margin-top-10" v-if="tab == 'politicas-de-privacidade'">
                            <hr>
                            <form type="post" v-on:submit.prevent="salvar()">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-10">
                                        <h3>
                                            <i class="material-icons">description</i>
                                            Políticas de privacidade
                                        </h3>
                                    </div>
                                    <div class="col-xl-12 col-xs-12 col-lg-12">
                                        <div class="row">

                                            <div class="col-xl-12 margin-bottom-15">
                                                <div class="submit-field">
                                                    <h5>Conteúdo:</h5>
                                                    <trumbowyg v-model="form['politicas-de-privacidade'].objeto.conteudo" :config="config" style="height: 400px;" class="" name="politicasPrivacidade"></trumbowyg>
                                                </div>
                                            </div>                                          

                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>    
                        </div>                                                                         

                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Configuracoes',
    components: {
        'Trumbowyg':                VueTrumbowyg.default,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['fontsize'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    // ['fullscreen']
                ]
            },               
            "loaded":               false,
            "tab":                  "",
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,  
                "sintomas":         {
                    "objeto": {
                        "habilitado":   1,
                        "pushTitulo": "",
                        "pushTexto": "",
                        "itens": [
                            {
                                "cod":  "",
                                "texto": "",
                                "itens": [
                                    {
                                        "cod":      "",
                                        "texto":    ""
                                    }
                                ]
                            }
                        ]
                    }
                },  
                "lembrete-agendamento":  {
                    "objeto": {
                        "tempo":        0,
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "pushLink":     "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },
                "confirmacao-agendamento":  {
                    "objeto": {
                        "tempo":        0,
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "pushLink":     "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },       
                "lembrete-retorno-agendamento":  {
                    "objeto": {
                        "tempo":        0,
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "pushLink":     "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },                  
                "feedback":  {
                    "objeto": {
                        "tempo":        0,
                        "link":         "",
                        "pushEnviar":   0,
                        "pushTitulo":   "",
                        "pushTexto":    "",
                        "smsEnviar":    0,
                        "smsTexto":     "",
                        "emailEnviar":  0,
                        "emailTitulo":  "",
                        "emailAssunto": "",
                        "whatsappEnviar":0,
                        "whatsappTexto":"",
                    }
                },                       
                "termos-de-uso":            {
                    "objeto": {
                        "conteudo":     ""
                    }
                },
                "politicas-de-privacidade": {
                    "objeto": {
                        "conteudo":     ""
                    }
                },                

            } 
        }
    },
    watch: {
                  
    },
    methods: {       
        setTab: function(tab, scroll = true) {
            var self        = this;
            console.log("setTab()", tab);
            if (self.tab == tab) return false;
            self.tab        = tab;
            loading.show();
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });  
            }, 100);
            self.getItens(scroll);
        },          
        add: function(itens, item) {
            console.log("add()", itens, item);
            var self            = this;
          
            
            item.cod        = md5((new Date()).getTime() + Math.random() + document.cookie + JSON.stringify(itens));
        
            itens.push(JSON.parse(JSON.stringify(item)));


            self.$forceUpdate();
             
        },
        del: function(itens, item) {
            console.log("del()", itens, item);
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                var index = itens.indexOf(item);
                itens.splice(index, 1);
                self.$forceUpdate();
            });
        },                      
        getItens: function(scroll = true) {
            var self        = this;
            return new Promise(function(resolve, reject) {

                self.loaded             = false;
                loading.show();

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         self.tab
                    }
                };
                console.log("getItens()", form);

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getItens() response", response);

                    self.form[response.data.result.nome] = response.data.result; 
                    self.loaded         = true;
                    self.$forceUpdate();
                    loading.hide();

                    if (scroll) {
                        setTimeout(function() {
                            $(".dashboard-content-inner")[0].scrollTo({
                                top:            $(".scroll-to")[0].getBoundingClientRect().top - 60,
                                behavior:       "smooth"
                            });             
                            // setTimeout(function() {
                            //     loading.hide();
                            // }, 200);
                        }, 200);
                    }

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getItens() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        salvar: function() {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form[self.tab]));
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.nome           = self.tab;

            console.log("salvar()", form);            

            self.loading.salvar = true;
            loading.show();
            axios.put("api/itens.php", form)
            .then(response => {
                
                self.loading.salvar = false;
                console.log("salvar() response", response)
                loading.hide();

                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });  

                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("salvar() error", error)
                loading.hide();
                self.loading.salvar = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },  
    },
    created: function() {
        var self = this;

        self.setTab("lembrete-agendamento", false);     

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    hr {
        opacity: 0.2;
    }
    h3 i {
        color: #59ba92;
    }   
    .button.block-mobile.small {
        border: 2px solid #59ba92;
    }
    .trumbowyg-editor {
        height: 500px !important;
    }
    textarea[name="politicasPrivacidade"] {
        display: none !important;
    }
    textarea[name="termosUso"] {
        display: none !important;
    }    
    .menu .button {
        margin-bottom: 0px;
        margin-right: 3px;
    }

    @media only screen and (max-width: 736px) { 
        .menu .button:not(:last-child) {
            border-bottom: 0px !important;
        }
        .menu .button {
            margin-right: 0px !important;
            border-top-right-radius: 0px;
            border-top-left-radius: 0px;
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
        }
        .menu .button:first-child {
            border-top-right-radius: 6px !important;
            border-top-left-radius: 6px !important;
        }        
        .menu .button:last-child {
            border-bottom-right-radius: 6px !important;
            border-bottom-left-radius: 6px !important;
        }                
    }
</style>



// WEBPACK FOOTER //
// src/components/Configuracoes.vue